require('./core');
require('./lib/mediator');
require('./lib/sibling');

// module.exports = 'ui-ng-sibling';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-sibling/src/main.js